import { utcToZonedTime } from 'date-fns-tz'
import { useAppSelector } from '../state/hooks'
export const useGetTimeHoursDifference = () => {
	const { localTimezone } = useAppSelector(state => state.settings)
	const userDate = new Date()
	const restaurantDate = utcToZonedTime(userDate, localTimezone)
	const timeHoursDifference = userDate.getHours() - restaurantDate.getHours()

	return timeHoursDifference
}
